import { NgModule } from "@angular/core";
import { FilterPipe, FilterPropertyPipe, FilterReceiptsPipe } from "./filter.pipe";
import { LanguagePipe } from "./language.pipe";
import { CurrencyPipe } from "./currency.pipe";
import { DisplayBonusPipe } from "./display-bonus.pipe";
import { DisplayCurrencyPipe } from "./display-currency.pipe";
import { FormatCurrencyPipe } from "./format-currency.pipe";
import { ReversePipe } from "./reverse.pipe";

@NgModule({
    declarations: [FilterPipe, FilterPropertyPipe, LanguagePipe,
        CurrencyPipe, DisplayBonusPipe, DisplayCurrencyPipe, FormatCurrencyPipe, ReversePipe, FilterReceiptsPipe

    ],
    exports: [FilterPipe, LanguagePipe, FilterPropertyPipe,
        CurrencyPipe, DisplayBonusPipe, DisplayCurrencyPipe, FormatCurrencyPipe, ReversePipe, FilterReceiptsPipe
    ],
    providers: [LanguagePipe, FilterPipe, FilterPropertyPipe]
})
export class AppPipesModule {

}
